// mui-table-theme.ts
import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

export const theme = createTheme({
      typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    fontSize: 14, // base font size in px
  },
  palette: {
    DataGrid: {
      headerBg: '#D9DDE8',
      bg: '#FFFFFF',
      pinnedBg: '#F5F5F5',
    },
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
          borderRadius: 0,
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 600,
            color: '#494949',
          },
          '& .MuiDataGrid-columnSeparator': {
            display: 'none',
          },
          // Sticky header support
          '& .MuiDataGrid-columnHeaders': {
            position: 'sticky',
            top: 0,
            zIndex: 1,
          },
          // Responsive adjustments
          '@media (max-width:600px)': {
            '& .MuiDataGrid-row, & .MuiDataGrid-cell': {
              fontSize: '12px',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: '14px',
            },
          },
        },
      },
    },
  },
});
